const congratsArr = [
  'Nailed it!',
  'Winner!',
  'Champ!',
  'BOOMS',
  'Done!',
  'Oh yeah!',
  'Holla!',
  'Congrats!',
];

export const randomCongrats = () =>
  congratsArr[Math.floor(Math.random() * congratsArr.length)];



// WEBPACK FOOTER //
// ./src/helpers/randomCongrats.js